import { __rest } from 'tslib';
import React__default from 'react';
import { ThemeProvider as ThemeProvider$1, useTheme as useTheme$1 } from '@emotion/react';
import { ModalProvider } from '../components/Modal/context.es.js';
import { ToastProviderDesktop } from '../components/Toast/desktop/context.es.js';
import { ToastProviderMobile } from '../components/Toast/mobile/context.es.js';
import { defaultTheme } from '../configs/Theme/index.es.js';

const ThemeProvider = (_a) => {
    var { children, theme = defaultTheme, customTheme } = _a, rest = __rest(_a, ["children", "theme", "customTheme"]);
    return (React__default.createElement(ThemeProvider$1, Object.assign({ theme: Object.assign(Object.assign({}, theme), customTheme) }, rest),
        React__default.createElement(ModalProvider, null,
            React__default.createElement(ToastProviderDesktop, null,
                React__default.createElement(ToastProviderMobile, null, children)))));
};
function useTheme() {
    const theme = useTheme$1();
    return theme;
}

export { ThemeProvider, useTheme };
